import { Component, OnInit, SimpleChanges, OnChanges, Input, OnDestroy, ViewChild, ElementRef, AfterViewInit, Output,
  EventEmitter, Inject, HostListener, NgZone} from '@angular/core';
import _ from 'lodash';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { DOCUMENT } from '@angular/common';
declare var $: any;

@Component({
  selector: 'app-virtual-tours-twodimension',
  animations: [
    trigger('openClose', [
      state('open', style({
        // transform: 'scale(1) translate(-40%, 60px)',
        display: 'block',
        opacity: '1',
        visibility: 'visible'
      })),
      state('closed', style({
        // transform: 'scale(0) translate(-40%, 60px)',
        animationDuration: '5s',
        animationDelay: '5s',
        display: 'block',
        opacity: '0',
        visibility: 'hidden'
      })),
      transition('open => closed', [
        animate('0.6s')
      ]),
      transition('closed => open', [
        animate('0.6s')
      ]),
    ]),
    trigger('toggleHighlightReels', [
      state('open', style({
        bottom: '0px',
      })),
      state('closed', style({
        bottom: '-140px',
      })),
    ]),
  ],
  templateUrl: './virtual-tours-twodimension.component.html',
  styleUrls: ['./virtual-tours-twodimension.component.scss']
})
export class VirtualToursTwodimensionComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @Input() spaceData;
  @Input() mediaData;
  @Input() floorplanData;
  @Input() selectedMedia;
  @Input() highLightReelData;

  @ViewChild('mainDiv') mainDiv: ElementRef;
  @ViewChild('rendererVirtualTourContainer') rendererVirtualTourContainer: ElementRef;
  @ViewChild('cssRendererContainer') cssRendererContainer: ElementRef;
  @ViewChild('floorPlanImage') floorPlanImage: ElementRef;
  // @ViewChild('sliderContent') sliderContent: OwlCarousel;
  @ViewChild('sliderContent') selectEvents: ElementRef;
  // @ViewChild('sliderContent') sliderContent: OwlCarousel;

  @Output() seletedMediaEmit = new EventEmitter();

  // carouselOptions = {
  //   dots: false,
  //   navigation: false,
  //   loop: false,
  //   autoplay: false,
  //   center: false,
  //   margin: 30, responsive: {
  //   0: {
  //       items: 1
  //   },
  //   600: {
  //       items: 3
  //   },
  //   1000: {
  //       items: 4
  //   },
  //   1400: {
  //       items: 6
  //   }
  // }};

  // Floorplan
  floorplanToggle = false;
  highlightToggle = false;
  floorplanHotspots: any;
  showFloorPlanHotspotData = false;
  readMoreClicked = false;
  readMoreSummaryClicked = false;
  selectedInfoImage: any;
  selectedInfoTag: any;
  toggle =  false;
  moreClicked = false;

  pointerEventsNone = false;
  cursorPointer = false;

  loading = true;
  playIconClicked = false;
  fullScreen = false;
  // three js basic controls
  animateId: any;
  controls = null;
  title = null;
  renderer = null;
  scene = null;
  camera = null;
  ambientLight = null;
  pointLight = null;
  geometry = null;
  material = null;
  raycaster = new THREE.Raycaster();
  mouse = new THREE.Vector2(0, 0);
  manualControl = false;

  // Canvas config
  CANVAS_HEIGHT = 850;
  CANVAS_WIDTH = 1200;
  CANVAS_CENTER_X = 0;
  CANVAS_CENTER_Y = 0;

  imagesData = [];
  sphereMesh = [];
  currentMesh: any;

  // Hotspots
  hotspotsMesh = [];
  hotspotsInfoMesh = [];
  infoHotspots = [];
  hoverInfoDiv: any;

  // VR effect
  effect: any;
  stereoEffect = false;

  spaceConfig = {
    show_drag: 1,
    auto_rotate: 1,
    show_control_buttons: 1,
    show_tour_button: 1,
    highlight_reel_count: 1000
  };

  toolTipHover = false;

  // Camera rotation codes
  cameraConfig = {
    isTweening: false,
    isUserInteracting: false,
    onMouseDownMouseX: 0,
    onMouseDownMouseY: 0,
    lon: 0,
    onMouseDownLon: 0,
    lat: 0,
    onMouseDownLat: 0,
    phi: 0,
    theta: 0,
    clientX: 0,
    clientY: 0,
    controlsSpeed: 600
  };

  cssScene = null;
  cssRenderer = null;

  infoDivShown = false;

  hotspotColor = '#ffc378';

  audioListener: any;
  soundMesh: any;
  audioContext: any;

  // highlight reel animation looping images
  autoplayAnimationInterval: any;
  currentHighlightAnimationCount = 1;
  currentHighlightReelData: any;


  @HostListener('document:fullscreenchange', ['$event'])
  @HostListener('document:webkitfullscreenchange', ['$event'])
  @HostListener('document:mozfullscreenchange', ['$event'])
  @HostListener('document:MSFullscreenChange', ['$event'])
    fullscreenmode() {
      this.fullScreen = !this.fullScreen;
      this.resizeHandler({});
    }

  constructor(
    @Inject(DOCUMENT) private document: any,
    private ngZone: NgZone
    ) {
  }

  ngOnInit() {
    // Existing code unchanged.
    // window.onload = () => {
    // this.audioContext = new AudioContext();
    // };

    this.scene = new THREE.Scene();
    // Css renderer
    this.cssScene = new THREE.Scene();
    this.cssRenderer = new THREE.CSS3DRenderer();
    THREE.Object3D.DefaultUp.set(0, 1, 0);
    this.renderer = new THREE.WebGLRenderer( { alpha: true, antialias: true } );
    const thisobject = this;
    $('body').on('click', '.hotspot-pulse', (event) => {
      if (event && event.currentTarget && event.currentTarget.id) {
        thisobject.hotspotClickedEvent(event.currentTarget.id);
      }
    });
    $('body').on('click', '.info-outer', (event) => {
      if (event && event.currentTarget && event.currentTarget.id) {
        thisobject.hotspotInfoClickedEvent(event.currentTarget.id);
      }
    });
  }

  // Owl Carousel
  initSlider(response) {
    if (response.length > 0) {
      const cardThis = this;
      this.ngZone.onMicrotaskEmpty.first().subscribe(() => {
        if ($(cardThis.selectEvents.nativeElement)) {
          setTimeout(() => {
            $(cardThis.selectEvents.nativeElement).owlCarousel({
              loop: true,
              margin: 30,
              nav: false,
              autoplay: false,
              smartSpeed: 1000,
              fluidSpeed: true,
              autoplayHoverPause: true,
              responsive: {
                0: {
                  items: 1
                },
                320: {
                  items: 3
                },
                425: {
                  items: 3
                },
                475: {
                  items: 3
                },
                768: {
                  items: 4
                },
                992: {
                  items: 5
                },
                1024: {
                  items: 5
                },
                1400: {
                  items: 6
                },
                1600: {
                  items: 7
                },
                2000: {
                  items: 9
                }
              }
            });
          }, 300);
        }
      });
    }
  }
  // Owl Carousel

  // Highlightreel
  startAnimationAutoplay() {
    const thisobject = this;
    let isitfirstTime = false;
    if (this.highLightReelData.length > 0) {
      if (!this.currentHighlightReelData) {
        const highLightReelData = _.find(this.highLightReelData, {media_id: this.selectedMedia.uuid});
        if (highLightReelData) {
          this.currentHighlightReelData = highLightReelData;
        } else {
          this.currentHighlightReelData = this.highLightReelData[0];
        }
        isitfirstTime = true;
      }
      this.autoplayAnimationInterval = setInterval( () => {
        const currentHighlightReelData = thisobject.changeIfItsLastIndexHighlightReel();
        thisobject.changeMediaFromHighlightReel(currentHighlightReelData);
      }, 10000);
    }
  }

  changeIfItsLastIndexHighlightReel() {
    const lastIndexof = _.findLastIndex(this.highLightReelData);
    const currentIndex = _.findIndex(this.highLightReelData, {uuid: this.currentHighlightReelData.uuid });
    // Check if loop config count of highlight reel has been completed
    if (lastIndexof === currentIndex) {
      this.currentHighlightReelData = this.highLightReelData[0];
      this.currentHighlightAnimationCount = this.currentHighlightAnimationCount + 1;
      if (this.currentHighlightAnimationCount > this.spaceConfig.highlight_reel_count) {
        this.playPauseVirtualTours();
      }
    } else {
      this.currentHighlightReelData = this.highLightReelData[currentIndex + 1];
    }
    return this.currentHighlightReelData;
  }

  changeMediaByHighlightReel(highlightReel) {
    const selectedMedia = _.find(this.mediaData, {uuid: highlightReel.media_id});
    if (selectedMedia) {
      this.changeMedia(selectedMedia);
    }
  }

  changeMediaFromHighlightReel(highlightReel) {

    const selectedMedia = _.find(this.mediaData, {uuid: highlightReel.media_id});
    if (selectedMedia) {
      // Change highlight reel data index and values on change of media
      this.currentHighlightReelData = highlightReel;
      this.changeMedia(selectedMedia);
    }
  }

  stopAnimationAutoplay() {
    clearInterval(this.autoplayAnimationInterval);
  }

  autoPlayHideShowCarousel() {
    if (this.playIconClicked) {
      this.startAnimationAutoplay();
    } else {
      this.currentHighlightAnimationCount = 1;
      this.stopAnimationAutoplay();
    }
  }

  toggleHighlight() {
    this.highlightToggle = !this.highlightToggle;
    if (this.highlightToggle) {
      this.floorplanToggle = false;
      this.toggle = false;
    }
  }

  changeHighlightReelFromMediaId(mediaId) {
    const highLightReelData = _.find(this.highLightReelData, {media_id: mediaId});
    if (highLightReelData) {
      this.currentHighlightReelData = highLightReelData;
    } else {
      this.currentHighlightReelData = this.highLightReelData[0];
    }
  }

  pauseVirtualToursAndHighlightreels() {
    this.playIconClicked = false;
    if (this.playIconClicked && this.soundMesh) {
      this.soundMesh.play();
    } else {
      if (this.soundMesh) {
        this.soundMesh.pause();
      }
    }
    // Play / stop highlight reels
    this.autoPlayHideShowCarousel();
  }

  // Highlightreel


  hotspotInfoClickedEvent(id) {
    this.closeInfoBox();
    this.infoHotspots = _.map(this.infoHotspots, (d) => {
      if (id === d.uuid) {
        d.hidden = false;
      }
      return d;
    });
  }

  closeInfoBox() {
    this.infoHotspots = _.map(this.infoHotspots, (d) => {
      d.hidden = true;
      return d;
    });
    setTimeout(() => {
      this.readMoreClicked = false;
    }, 200);
  }


  // infoHotspotHoverEvent(uuid, event, thisobject, isMouseOver) {
  //   const singleMesh = _.find(this.hotspotsInfoMesh, {name: uuid});
  //   if (!this.playIconClicked && isMouseOver && !this.hoverInfoDiv && singleMesh && singleMesh.userData && !this.infoDivShown) {
  //       const canvasBounds = this.cssRenderer.domElement.getBoundingClientRect();
  //       const offset = thisobject.find('.info-icon').offset();
  //       const left  = offset.left - canvasBounds.left;
  //       const top = offset.top - canvasBounds.top;
  //       this.infoHotspots = _.map(this.infoHotspots, (d) => {
  //         if (uuid === d.uuid) {
  //           if ($('#infoTooltip' + d.uuid)) {
  //             $('#infoTooltip' + d.uuid).css({
  //               top: `${(top)}px`,
  //               left: `${left}px`
  //             });
  //           }
  //           d.hidden = false;
  //         }
  //         return d;
  //       });
  //       this.infoDivShown = true;
  //   }
  // }

  ngAfterViewInit() {
    this.init();
    setTimeout(() => {
      this.showFloorPlanHotspotData = true;
    }, 2000);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initSlider(this.highLightReelData);
    // Changes in hotspots
    if (changes.selectedMedia && changes.selectedMedia.currentValue) {
      this.removeHotspotMesh();
      this.selectedMedia = changes.selectedMedia.currentValue;
      this.updateHiddenTagsInfoMediaHotspot();
      this.changeSphereMesh();
    }
    if (changes.spaceData && changes.spaceData.currentValue) {
      this.updateSpaceConfig(changes.spaceData.currentValue.config);
    }
    // Floorplan
    if (changes.floorplanData && changes.floorplanData.currentValue) {
      const floorplanData = changes.floorplanData.currentValue;
      this.floorplanHotspots = floorplanData && floorplanData.hotspot ? floorplanData.hotspot : [];
    }
  }

  toggleFloorplan() {
    this.floorplanToggle = !this.floorplanToggle;
    if (this.floorplanToggle) {
      this.highlightToggle = false;
    }
  }

  updateHiddenTagsInfoMediaHotspot() {
    this.infoHotspots = [];
    if (this.selectedMedia && this.selectedMedia.hotspot_info && this.selectedMedia.hotspot_info.length > 0) {
      this.selectedMedia.hotspot_info = _.map(this.selectedMedia.hotspot_info, (info) => {
        info.hidden = true;
        this.infoHotspots.push(info);
        return info;
      });
    }
  }

  updateSpaceConfig(configData) {
    this.spaceConfig.show_drag = configData.show_drag ? configData.show_drag : false;
    this.spaceConfig.auto_rotate = configData.auto_rotate  ? configData.auto_rotate : false;
    this.spaceConfig.show_control_buttons = configData.show_control_buttons  ? configData.show_control_buttons : false;
    this.spaceConfig.show_tour_button = configData.show_tour_button  ? configData.show_tour_button : false;
    // update loopHighlightAnimationCountLimit count from space config
    this.spaceConfig.highlight_reel_count = configData.highlight_reel_count  ? configData.highlight_reel_count : 1000;
  }

  onMouseMove( event ) {

    if (this.camera) {
      // Image rotation
      this.manualControl = true;
      if (this.cameraConfig.isUserInteracting === true) {
        if ((event.target && event.target.parentElement && event.target.parentElement.id === 'css') ||
        (event.target && event.target.parentNode && event.target.parentNode.parentElement && event.target.parentNode.parentElement.id === 'css')
        ) {
            this.closeInfoBox();
            // this.infoHotspotHoveroutEvent();
            this.cameraConfig.clientX = event.clientX || (event.tources && event.tources[0] && event.touches[ 0 ].clientX ? event.touches[ 0 ].clientX : 0);
            this.cameraConfig.clientY = event.clientY || (event.tources && event.tources[0] && event.touches[ 0 ].clientY ? event.touches[ 0 ].clientY : 0);

            // tween opacity back to originals
            const targetLat = ( this.cameraConfig.clientY - this.cameraConfig.onMouseDownMouseY ) * 0.2 + this.cameraConfig.onMouseDownLat;
            const targetLon = ( this.cameraConfig.onMouseDownMouseX - this.cameraConfig.clientX ) * 0.2 + this.cameraConfig.onMouseDownLon;

            if (targetLat && targetLon) {
              this.cameraConfig.isTweening = true;
              const tweenOpacity = new TWEEN.Tween(this.cameraConfig)
                .to({ lat: targetLat, lon: targetLon}, this.cameraConfig.controlsSpeed)
                .easing(TWEEN.Easing.Quadratic.Out)
                .onUpdate(() => {
                })
                .onComplete(() => {
                  this.cameraConfig.isTweening = false;
                });
              tweenOpacity.start();
            }

          // this.cameraConfig.lon = ( this.cameraConfig.onMouseDownMouseX - this.cameraConfig.clientX ) * 0.1 + this.cameraConfig.onMouseDownLon;
          // this.cameraConfig.lat = ( this.cameraConfig.clientY - this.cameraConfig.onMouseDownMouseY ) * 0.1 + this.cameraConfig.onMouseDownLat;
        }
      }
    }
  }

  onMouseDown(event) {
    this.manualControl = false;
    if (this.camera) {
      if ((event.target && event.target.parentElement && event.target.parentElement.id === 'css') ||
        (event.target && event.target.parentNode && event.target.parentNode.parentElement && event.target.parentNode.parentElement.id === 'css')
        ) {
        this.closeInfoBox();
        this.cameraConfig.isUserInteracting = true;
        this.cameraConfig.clientX = (event && event.clientX) || (event && event.touches[ 0 ].clientX);
        this.cameraConfig.clientY = (event && event.clientY) || (event && event.touches[ 0 ].clientY);
        this.cameraConfig.onMouseDownMouseX = this.cameraConfig.clientX;
        this.cameraConfig.onMouseDownMouseY = this.cameraConfig.clientY;
        this.cameraConfig.onMouseDownLon = this.cameraConfig.lon;
        this.cameraConfig.onMouseDownLat = this.cameraConfig.lat;
      }
    }
  }

  onMouseUp(event) {
    if (this.camera) {
      if ((event.target && event.target.parentElement && event.target.parentElement.id === 'css') ||
        (event.target && event.target.parentNode && event.target.parentNode.parentElement && event.target.parentNode.parentElement.id === 'css')
        ) {
        // Camera rotation and sphere rotation
        this.cameraConfig.isUserInteracting = false;
      }
    }
  }

  zoomInOut( zoomType ) {
    let fov;
    if (zoomType === 'in') {
      fov = this.camera.fov - 5;
      if (fov >= 35) {
        const tween = new TWEEN.Tween(this.camera).to({fov}, 300);
        tween.onUpdate(() => {
          this.camera.updateProjectionMatrix();
        });
        tween.start();
      }
    } else if (zoomType === 'out') {
      fov = this.camera.fov + 5;
      if (fov <= 75) {
        const tween = new TWEEN.Tween(this.camera).to({fov}, 300);
        tween.onUpdate(() => {
          this.camera.updateProjectionMatrix();
        });
        tween.start();
      }
    }
  }

  // Helper to show axis and camera axis
  addHelper() {
    const axesHelper = new THREE.AxesHelper( 5 );
    this.scene.add( axesHelper );
  }

  init() {
    this.CANVAS_WIDTH = Math.round(parseFloat(getComputedStyle(this.rendererVirtualTourContainer.nativeElement).width));
    this.CANVAS_HEIGHT = Math.round(parseFloat(getComputedStyle(this.rendererVirtualTourContainer.nativeElement).height));
    this.CANVAS_CENTER_X = this.CANVAS_WIDTH / 2;
    this.CANVAS_CENTER_Y = this.CANVAS_HEIGHT / 2;

    // Css renderer
    this.cssRenderer.setSize( this.CANVAS_WIDTH, this.CANVAS_HEIGHT );
    this.cssRenderer.domElement.style.position = 'absolute';
    this.cssRenderer.domElement.style.top = 0;
    this.cssRendererContainer.nativeElement.appendChild(this.cssRenderer.domElement);

    this.renderer.setPixelRatio( window.devicePixelRatio );
    this.renderer.setSize( this.CANVAS_WIDTH, this.CANVAS_HEIGHT );
    this.renderer.setClearColor('#0C7CA5', 0);
    this.rendererVirtualTourContainer.nativeElement.appendChild(this.renderer.domElement);

    // Web vr
    // this.renderer.vr.enabled = true;
    // this.rendererVirtualTourContainer.nativeElement.appendChild( WEBVR.createButton( this.renderer, { frameOfReferenceType: 'head-model' } ) );



    this.camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 1, 1000 );
    this.camera.target = new THREE.Vector3( 0, 0, 0 );

    // this.camera.position.x = 20;
    // this.camera.position.y = 20;
    // this.camera.position.z = 20;

    // this.controls = new THREE.OrbitControls( this.camera, this.renderer.domElement );
    // this.controls.target = new THREE.Vector3(0, 0, 0);

    // this.controls.enableZoom = false;
    // this.controls.enablePan = false;
    // this.controls.enableDamping = true;
    // this.controls.autoRotate = this.spaceConfig.auto_rotate ? this.spaceConfig.auto_rotate : false;

    this.playIconClicked = this.spaceConfig.auto_rotate ? true : false;

    // this.controls.autoRotateSpeed = - 0.3;
    // this.controls.rotateSpeed = - 0.1;

    // VR effect
    // Add the VR screen effect.
    this.effect = new THREE.StereoEffect(this.renderer);
    // this.effect.eyeSeparation = 5;
    this.effect.setSize( this.CANVAS_WIDTH, this.CANVAS_HEIGHT );


    // scene
    this.ambientLight = new THREE.AmbientLight( 0xcccccc, 0.4 );
    this.scene.add( this.ambientLight );
    this.pointLight = new THREE.PointLight( 0xffffff, 0.8 );
    this.camera.add( this.pointLight );
    this.scene.add( this.camera );

    this.createSphereAndHotspots();

    this.addHelper();

    this.animate();
  }

  addAudioFileVirtualTour() {
    if (this.spaceData && this.spaceData.audio && this.spaceData.audio !== '' && this.spaceData.audio !== null) {
      this.audioContext = new AudioContext();
      this.audioContext.resume().then(() => {
        console.log('Playback resumed successfully');
      });
      // create an AudioListener and add it to the camera
      this.audioListener = new THREE.AudioListener();
      this.camera.add( this.audioListener );
      // create a global audio source
      this.soundMesh = new THREE.Audio( this.audioListener );
      // load a sound and set it as the Audio object's buffer
      const audioLoader = new THREE.AudioLoader();
      // tslint:disable-next-line:only-arrow-functions
      audioLoader.load( this.spaceData.audio, ( buffer ) => {
        if (this.soundMesh) {
          this.soundMesh.setBuffer( buffer );
          this.soundMesh.setLoop( true );
          this.soundMesh.setVolume( 1 );
          if (this.playIconClicked) {
            this.soundMesh.play();
          } else {
            this.soundMesh.pause();
          }
        }
      });
    }
  }

  createSphereAndHotspots() {
    if (this.camera && this.scene) {
      this.removeHotspotMesh();
      const geometry = new THREE.SphereBufferGeometry( 500, 60, 40 );
      // invert the geometry on the x-axis so that all of the faces point inward
      geometry.scale( - 1, 1, 1 );
      const loader = new THREE.TextureLoader();
      const texturePromises = [];
      let i;
      for (i = 0; i <  this.mediaData.length; i++) {
        const objectJson =  this.mediaData[i];
        const promiseData = new Promise((resolve, reject) => {
          return loader.load(`${objectJson.url}`,
            texture => {
              objectJson.texture = texture;
              if (objectJson.texture instanceof THREE.Texture) {
                resolve(objectJson);
              }
            },
            xhr => {
              console.log(`${objectJson.url}` + ' ' + (xhr.loaded / xhr.total * 100) + '% loaded');
            },
            xhr => {
              reject(new Error(xhr + 'An error occurred loading while loading: ' + `${objectJson.url}`));
            }
          );
        });
        texturePromises.push(promiseData);
      }
      Promise.all(texturePromises).then(loadedTextures => {
        let j;
        for (j = 0; j < loadedTextures.length; j++) {
          if (this.scene) {
            const jsonData = loadedTextures[j];
            const sphereMaterial = new THREE.MeshBasicMaterial({
              map: jsonData.texture,
              transparent: true,
              opacity: 0
            });
            const sphereMesh = new THREE.Mesh( geometry, sphereMaterial );
            sphereMesh.name = jsonData.uuid;
            sphereMesh.material.side =  THREE.DoubleSide;
            this.sphereMesh[j] = sphereMesh;
            this.scene.add(sphereMesh);
            if (this.selectedMedia && this.selectedMedia.uuid === jsonData.uuid) {
              sphereMesh.material.opacity = 1;
              this.changeCameraLatLong(this.selectedMedia);
              this.currentMesh = sphereMesh;
              this.addMediaHotspot(jsonData, sphereMesh);
              this.addMediaInfoHotspot(jsonData, sphereMesh);
            } else {
              sphereMesh.visible = false;
            }
            if (j === loadedTextures.length - 1) {
              // Auto play carousel highlight reels
              this.autoPlayHideShowCarousel();
              this.loading = false;
              // Add audio files
              this.addAudioFileVirtualTour();
            }
          }
        }
      });
    }
  }

  updateSphereHotspot() {
    // Remove hotspots
    this.removeHotspotMesh();
    let j;
    for (j = 0; j < this.imagesData.length; j++) {
      const jsonData = this.imagesData[j];
      const sphereMesh = _.find(this.sphereMesh, {name: jsonData.uuid});
      if (sphereMesh) {
        if (this.selectedMedia && this.selectedMedia.uuid === sphereMesh.name) {
          sphereMesh.material.opacity = 1;
          this.changeCameraLatLong(this.selectedMedia);
          this.currentMesh = sphereMesh;
          this.updateHiddenTagsInfoMediaHotspot();
          this.addMediaHotspot(jsonData, sphereMesh);
          this.addMediaInfoHotspot(jsonData, sphereMesh);
          this.loading = false;
        } else if (j === 0) {
          sphereMesh.material.opacity = 1;
          this.changeCameraLatLong(this.selectedMedia);
          this.currentMesh = sphereMesh;
          this.addMediaHotspot(jsonData, sphereMesh);
          this.addMediaInfoHotspot(jsonData, sphereMesh);
          this.loading = false;
        } else {
          sphereMesh.visible = false;
        }
      }
    }
  }

  // Link hotspot
  addMediaHotspot(jsonData, sphereMesh) {
    if (jsonData && jsonData.hotspot) {
      let i;
      for (i = 0; i < jsonData.hotspot.length; i++) {
        const hotspots = jsonData.hotspot[i];
        this.createMediaHotspot(hotspots, sphereMesh);
      }
    }
  }

  createMediaHotspot(hotspot, sphereMesh) {
    const color = hotspot.color ? hotspot.color : this.hotspotColor;
    let content = '';
    const rgbcolor1 = this.hexToRgbA(color, 0.7);
    const rgbcolor2 = this.hexToRgbA(color, 0);
    content += '<div class="hotspot-pulse" data-id="' + hotspot.uuid + '" id="' + hotspot.uuid + '" data-color="' + color + '"  style="--rgbcolor1: ' + rgbcolor1 + ';--rgbcolor2: ' + rgbcolor2 + ';border: 5px solid ' + color + '">';
    content += '<div class="pulse" style="border: 2px solid ' + color + '" >';
    content += '<div class="hotspot-title"><p> ' + hotspot.title + ' </p></div>';
    content += '</div>';
    content += '</div>';
    const element = document.createElement('div');
    element.innerHTML = content;

    const sprite = new THREE.CSS3DSprite( element );
    sprite.scale.set(0.1, 0.1, 0.1);

    sprite.position.set(hotspot.coordinates.x, hotspot.coordinates.y, hotspot.coordinates.z);
    sprite.name = hotspot.media_link.uuid;
    sprite.hotspot_type = 'link';
    sprite.userData = hotspot;
    if (sphereMesh && sphereMesh.name === this.selectedMedia.uuid) {
      this.hotspotsMesh.push(sprite);
    }
    this.cssScene.add( sprite );
  }

  hexToRgbA(hex, opacity) {
    let c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        // tslint:disable-next-line:no-bitwise
        return 'rgba(' + [(c >> 16) & 255, ( c >> 8) & 255, c & 255].join(',') + ', ' + opacity + ' )';
    }
    throw new Error('Bad Hex');
  }
  // Link hotspot

  // Info hotspots
  addMediaInfoHotspot(selectedMedia, sphereMesh) {
    if (selectedMedia && selectedMedia.hotspot_info) {
      let i;
      for (i = 0; i < selectedMedia.hotspot_info.length; i++) {
        const hotspots = selectedMedia.hotspot_info[i];
        this.createMediaInfoHotspot(hotspots, sphereMesh);
      }
    }
  }

  createMediaInfoHotspot(hotspot, sphereMesh) {
    let content = '';
    content += '<div class="info-outer" data-id="' + hotspot.uuid + '" id="' + hotspot.uuid + '" >';
    content += '<div class="info-hotspot-pulse">';
    content += '<div class="info-icon">';
    content += '<img src="assets/images/icons/main-info.png">';
    content += '</div>';
    content += '</div>';
    content += '</div>';
    const element = document.createElement('div');
    element.innerHTML = content;

    const sprite = new THREE.CSS3DSprite( element );
    sprite.scale.set(0.1, 0.1, 0.1);

    sprite.position.set(hotspot.coordinates.x, hotspot.coordinates.y, hotspot.coordinates.z);
    sprite.name = hotspot.uuid;
    sprite.hotspot_type = 'info';
    sprite.userData = hotspot;
    if (sphereMesh && sphereMesh.name === this.selectedMedia.uuid) {
      this.hotspotsInfoMesh.push(sprite);
    }
    this.cssScene.add( sprite );
  }
  // Info hotspots

  hotspotClickedEvent(uuid) {
    const hotspotData = _.find(this.hotspotsMesh , (mesh) => {
      if (mesh && mesh.userData && mesh.userData.uuid && mesh.userData.uuid === uuid) {
        return mesh;
      }
    });
    if (hotspotData && hotspotData.userData && hotspotData.userData.media_link && hotspotData.userData.media_link.uuid) {
      // Change highlight reel if any
      this.changeHighlightReelFromMediaId(hotspotData.userData.media_link.uuid);
      this.animateAndChangeImage(hotspotData.userData, hotspotData.userData.media_link.uuid);
    }
  }

  onProgressObjectLoader(xhr) {

  }

  onErrorObjectLoader(xhr) {

  }

  animate() {
    this.animateId = requestAnimationFrame(this.animate.bind(this));
    // Rotate 360 image
    if ( this.cameraConfig.isUserInteracting === false && this.playIconClicked) {
      this.cameraConfig.lon += 0.1;
    }

    if (this.camera) {
      this.cameraConfig.lat = Math.max( - 85, Math.min( 85, this.cameraConfig.lat ) );
      this.cameraConfig.phi = THREE.Math.degToRad( 90 - this.cameraConfig.lat );
      this.cameraConfig.theta = THREE.Math.degToRad( this.cameraConfig.lon );


      // if (this.currentMesh) {
      //   this.currentMesh.rotation.y = this.cameraConfig.theta;
      //   this.currentMesh.rotation.x = this.cameraConfig.phi;
      // }
      // if (this.currentMesh) {
      //   const tempV = new THREE.Vector3();
      //   let i;
      //   for (i = 0; i < this.currentMesh.hotspots.length; i++) {
      //     const element = this.currentMesh.elements[i];
      //     const hotspot = this.currentMesh.hotspots[i];
      //     // get the position of the center of the cube
      //     hotspot.updateWorldMatrix(true, false);
      //     hotspot.getWorldPosition(tempV);

      //     // get the normalized screen coordinate of that position
      //     // x and y will be in the -1 to +1 range with x = -1 being
      //     // on the left and y = -1 being on the bottom
      //     tempV.project(this.camera);

      //     // convert the normalized position to CSS coordinates
      //     const x = (tempV.x *  .5 + .5) * this.CANVAS_WIDTH;
      //     const y = (tempV.y * -.5 + .5) * this.CANVAS_HEIGHT;
      //     // transform: translate3d(540px, 484.5px, 0px) perspective(347.874px) rotateZ(0deg) translateZ(347.874px) rotateX(-42.2364deg) rotateY(-96.3968deg) translate3d(0px, 0px, 0px) rotateY(84.701deg) rotateX(28.619deg) scale3d(1, 1, 1) translateZ(-200px) rotate(0deg) translate(0px, 0px) rotateZ(0deg) rotateX(-15deg) rotateY(0deg) scale(0.08, 0.08) translate(-150px, 0px);

      //     const rotateX = 90 - this.cameraConfig.lat;
      //     const rotateY = this.cameraConfig.lon;
      //     // move the elem to that position
      //     // tslint:disable-next-line:max-line-length
      //     // translate(-50%, -50%) translate(${x}px,${y}px)
      //     element.style.transform = `translate3d(540px, 484.5px, 0px) perspective(347.874px) rotateZ(0deg) translateZ(347.874px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translate3d(0px, 0px, 0px) rotateY(84.701deg) rotateX(28.619deg) scale3d(1, 1, 1) translateZ(-200px) rotate(0deg) translate(0px, 0px) rotateZ(0deg) rotateX(-15deg) rotateY(0deg) scale(0.08, 0.08) translate(-150px, 0px)`;
      //   }
      // }


      this.camera.target.x = 500 * Math.sin( this.cameraConfig.phi ) * Math.cos( this.cameraConfig.theta );
      this.camera.target.y = 500 * Math.cos( this.cameraConfig.phi );
      this.camera.target.z = 500 * Math.sin( this.cameraConfig.phi ) * Math.sin( this.cameraConfig.theta );
      this.camera.lookAt( this.camera.target );
      this.updateMetaTagsRotationOnMouseMove();
      TWEEN.update();
      this.render();
    }

    // this.controls.update();
  }

  render() {
    if (this.renderer) {
      if (this.stereoEffect) {
        this.effect.render(this.scene, this.camera);
      } else {
        this.renderer.render(this.scene, this.camera);
      }

      // this.renderer.setAnimationLoop( this.render );
    }

    if (this.cssRenderer) {
      this.cssRenderer.render( this.cssScene, this.camera );
    }
  }

  resizeHandler(event) {

    if (this.renderer) {
      if ( this.fullScreen) {
        this.CANVAS_WIDTH = window.innerWidth;
        this.CANVAS_HEIGHT = window.innerHeight;
      } else {
        this.CANVAS_WIDTH = Math.round(parseFloat(getComputedStyle(this.rendererVirtualTourContainer.nativeElement).width));
        this.CANVAS_HEIGHT = Math.round(parseFloat(getComputedStyle(this.rendererVirtualTourContainer.nativeElement).height));
      }
      this.camera.aspect = this.CANVAS_WIDTH / this.CANVAS_HEIGHT;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize( this.CANVAS_WIDTH, this.CANVAS_HEIGHT );
      // Css renderer
      this.cssRenderer.setSize( this.CANVAS_WIDTH, this.CANVAS_HEIGHT );
    }
    // Vr effect
    if (this.effect) {
      this.effect.setSize( this.CANVAS_WIDTH, this.CANVAS_HEIGHT );
    }
  }

  // onDocumentMouseWheel( event ) {
  //   const fov = this.camera.fov + event.deltaY * 0.09;
  //   this.camera.fov = THREE.Math.clamp( fov, 10, 75 );
  //   this.camera.updateProjectionMatrix();
  // }

  ngOnDestroy() {
    this.removeComponentProperties();
  }

  playPauseVirtualTours() {
    this.playIconClicked = !this.playIconClicked;
    if (this.playIconClicked && this.soundMesh) {
      this.soundMesh.play();
    } else {
      if (this.soundMesh) {
        this.soundMesh.pause();
      }
    }
    // Play / stop highlight reels
    this.autoPlayHideShowCarousel();
  }

  previousImage() {
    const currentIndex = _.findIndex(this.sphereMesh, {name: this.currentMesh.name });
    if (currentIndex > 0) {
      const previousIndex = currentIndex - 1;
      if (this.sphereMesh && this.sphereMesh[previousIndex]) {
        this.pauseVirtualToursAndHighlightreels();
        const oldMesh = this.currentMesh;
        this.resetCameraLatLong();
        this.currentMesh = this.sphereMesh[previousIndex];
        this.changeMediaFromHighlightReel(this.currentMesh.name);
        this.animateOldNewMesh(oldMesh, this.currentMesh);
      }
    }
  }

  nextImage() {
    const currentIndex = _.findIndex(this.sphereMesh, {name: this.currentMesh.name });
    const nextIndex = currentIndex + 1;
    if (this.sphereMesh && this.sphereMesh[nextIndex]) {
      this.pauseVirtualToursAndHighlightreels();
      const oldMesh = this.currentMesh;
      this.resetCameraLatLong();
      this.currentMesh = this.sphereMesh[nextIndex];
      this.changeMediaFromHighlightReel(this.currentMesh.name);
      this.animateOldNewMesh(oldMesh, this.currentMesh);
    }
  }

  changeMedia(media) {
    const currentIndex = _.findIndex(this.sphereMesh, {name: this.currentMesh.name });
    const nextIndex = _.findIndex(this.sphereMesh, {name: media.uuid });
    if (this.sphereMesh && this.sphereMesh[nextIndex]) {
      const oldMesh = this.currentMesh;
      this.resetCameraLatLong();
      this.currentMesh = this.sphereMesh[nextIndex];
      this.animateOldNewMesh(oldMesh, this.currentMesh);
    }
  }

  resetCameraLatLong() {
    this.cameraConfig.lat = 0;
    this.cameraConfig.lon = 0;
    // this.camera.target = new THREE.Vector3( 0, 0, 0 );
  }

  changeCameraLatLong(selectedMedia) {
    if (selectedMedia && selectedMedia.orientation && selectedMedia.orientation !== '') {
      this.cameraConfig.lat = selectedMedia.orientation.x;
      this.cameraConfig.lon = selectedMedia.orientation.y;
    }
  }

  animateAndChangeImage(hotspotData, uuid) {
    if (uuid && this.camera) {
      const oldMesh = this.currentMesh;
      this.hotspotsMesh = [];
      this.sphereMesh = _.map(this.sphereMesh, (mesh) => {
        if (mesh.name === uuid) {
          this.currentMesh = mesh;
        }
        return mesh;
      });
      const currentCameraFov = this.camera.fov;
      const tween = new TWEEN.Tween(this.camera).to({fov: currentCameraFov - 10}, 800);
      const selectedMedia = _.find(this.mediaData, {uuid: this.currentMesh.name});
      tween.onStart(() => {
        this.removeHotspotMesh();
        this.fadeMesh(oldMesh, 'out');
        this.fadeMesh(this.currentMesh, 'in');
      });
      tween.onUpdate(() => {
        this.camera.updateProjectionMatrix();
      });
      tween.onComplete(() => {
        if (hotspotData && hotspotData.orientation && hotspotData.orientation !== '') {
          this.resetCameraLatLong();
          this.cameraConfig.lat = hotspotData.orientation.x;
          this.cameraConfig.lon = hotspotData.orientation.y;
        }
        this.camera.fov = currentCameraFov;
        this.camera.updateProjectionMatrix();
        this.seletedMediaEmit.emit(selectedMedia);
      });
      tween.easing(TWEEN.Easing.Linear.None);
      tween.start();
    }
  }

  fadeMesh(mesh, direction) {
    if (direction === 'out') {
      const tweenOpacity = new TWEEN.Tween(mesh.material)
          .to({ opacity: 0 }, 1200)
          .easing(TWEEN.Easing.Linear.None)
          .onComplete(() => {
            // mesh.visible = false;
          });
      tweenOpacity.start();
      return tweenOpacity;
    }
    if (direction === 'in') {
      mesh.visible = true;
      const tweenOpacity = new TWEEN.Tween(mesh.material)
          .to({ opacity: 1 }, 1200)
          .easing(TWEEN.Easing.Linear.None)
          .onComplete(() => {
          });
      tweenOpacity.start();
      return tweenOpacity;
    }
  }

  // animateAndChangeImage(intersectedMesh) {
  //   if (intersectedMesh.object) {
  //     const oldMesh = this.currentMesh;
  //     this.hotspotsMesh = [];
  //     this.sphereMesh = _.map(this.sphereMesh, (mesh) => {
  //       if (mesh.name === intersectedMesh.object.name) {
  //         this.currentMesh = mesh;
  //       }
  //       return mesh;
  //     });

  //     const currentCameraFov = this.camera.fov;
  //     const tween = new TWEEN.Tween(this.camera).to({fov: currentCameraFov - 15}, 600);
  //     const selectedMedia = _.find(this.imagesData, {uuid: this.currentMesh.name});
  //     this.currentMesh.visible = true;
  //     // this.currentMesh.rotation.x += this.cameraConfig.lon;
  //     // this.currentMesh.rotation.x += this.cameraConfig.lon;
  //     this.fadeMesh(oldMesh, 'in', undefined);
  //     this.fadeMesh(this.currentMesh, 'out', undefined);

  //     // if (selectedMedia && selectedMedia.orientation && selectedMedia.orientation !== '') {
  //     //   this.cameraConfig.lat = selectedMedia.orientation.x;
  //     //   this.cameraConfig.lon = selectedMedia.orientation.y;
  //     // }
  //     tween.onUpdate(() => {

  //       // this.resetCameraLatLong();

  //       this.camera.updateProjectionMatrix();

  //       // Remove hotspots
  //       this.removeHotspotMesh();

  //       // let i;
  //       // const meshChildren = oldMesh.children ? oldMesh.children : [];
  //       // for (i = meshChildren.length - 1; i >= 0; i--) {
  //       //   oldMesh.remove(meshChildren[i]);
  //       // }

  //       // if (selectedMedia && selectedMedia.orientation && selectedMedia.orientation !== '') {
  //       //   this.cameraConfig.lat = selectedMedia.orientation.x;
  //       //   this.cameraConfig.lon = selectedMedia.orientation.y;
  //       // }

  //     });
  //     tween.onComplete(() => {
  //       // this.currentMesh.material.transparent = false;
  //       oldMesh.visible = false;
  //       this.resetCameraLatLong();

  //       if (intersectedMesh && intersectedMesh.object && intersectedMesh.object.userData && intersectedMesh.object.userData.orientation && intersectedMesh.object.userData.orientation !== '') {
  //         this.cameraConfig.lat = intersectedMesh.object.userData.orientation.x;
  //         this.cameraConfig.lon = intersectedMesh.object.userData.orientation.y;
  //       }
  //       this.camera.fov = currentCameraFov;
  //       this.camera.updateProjectionMatrix();
  //       this.seletedMediaEmit.emit(selectedMedia);
  //     });
  //     tween.easing(TWEEN.Easing.Linear.None);
  //     tween.start();
  //   }
  // }

  openFullscreen() {
    if (!this.fullScreen) {
      const element  = this.mainDiv.nativeElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    }
  }

  exitFullScreen() {
    if (this.fullScreen) {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        this.document.msExitFullscreen();
      }
    }
  }

  enableVrMode() {
    this.stereoEffect = !this.stereoEffect;
    this.resizeHandler(true);
    this.render();
  }

  removeHotspotMesh() {
    if ($('.hotspot-pulse')) {
      $('.hotspot-pulse').each(function() {
        $(this).remove();
      });
    }
    if ($('.info-outer')) {
      $('.info-outer').each(function() {
        $(this).remove();
      });
    }
    let i;
    for (i = 0; i < this.hotspotsMesh.length; i++) {
        if (this.hotspotsMesh[i]) {
          this.cssScene.remove(this.hotspotsMesh[i]);
        }
    }
    this.hotspotsMesh = [];

    // Remove info hotspot mesh
    let j;
    for (j = 0; j < this.hotspotsInfoMesh.length; j++) {
        if (this.hotspotsInfoMesh[j]) {
          this.cssScene.remove(this.hotspotsInfoMesh[j]);
        }
    }
    this.hotspotsInfoMesh = [];

  }

  changeSphereMesh() {
    if (this.selectedMedia) {
      // Remove hotspots
      this.removeHotspotMesh();
      this.sphereMesh = _.map(this.sphereMesh, (mesh) => {
        if (mesh.name === this.selectedMedia.uuid) {
          this.currentMesh = mesh;
          mesh.visible = true;
          this.addMediaHotspot(this.selectedMedia, mesh);
          this.addMediaInfoHotspot(this.selectedMedia, mesh);
        } else {
          mesh.visible = false;
        }
        return mesh;
      });
    }
  }

  rightControls() {
    const targetLon = this.cameraConfig.lon + 20;
    const tweenOpacity = new TWEEN.Tween(this.cameraConfig)
      .to({ lon: targetLon}, this.cameraConfig.controlsSpeed)
      .easing(TWEEN.Easing.Quadratic.Out)
      .onUpdate(() => {
      })
      .onComplete(() => {
      });
    tweenOpacity.start();

  }

  leftControls() {
    const targetLon = this.cameraConfig.lon - 20;
    const tweenOpacity = new TWEEN.Tween(this.cameraConfig)
      .to({ lon: targetLon}, this.cameraConfig.controlsSpeed)
      .easing(TWEEN.Easing.Quadratic.Out)
      .onUpdate(() => {
      })
      .onComplete(() => {
      });
    tweenOpacity.start();
  }

  upControls() {

    const targetLat = this.cameraConfig.lat + 20;
    const tweenOpacity = new TWEEN.Tween(this.cameraConfig)
      .to({ lat: targetLat}, this.cameraConfig.controlsSpeed)
      .easing(TWEEN.Easing.Quadratic.Out)
      .onUpdate(() => {
      })
      .onComplete(() => {
      });
    tweenOpacity.start();
  }

  downControls() {

    const targetLat = this.cameraConfig.lat - 20;
    const tweenOpacity = new TWEEN.Tween(this.cameraConfig)
      .to({ lat: targetLat}, this.cameraConfig.controlsSpeed)
      .easing(TWEEN.Easing.Quadratic.Out)
      .onUpdate(() => {
      })
      .onComplete(() => {
      });
    tweenOpacity.start();
  }

  getPlayPauseText() {
    if (this.playIconClicked) {
      return 'Pause';
    }
    return 'Play';
  }

  mouseEnterTagDiv() {
    this.toolTipHover = true;
  }

  updateMetaTagsRotationOnMouseMove() {
    let i;
    for (i = 0; i < this.hotspotsInfoMesh.length; i++) {
      const ringMesh = this.hotspotsInfoMesh[i];
      ringMesh.setRotationFromQuaternion(this.camera.quaternion);
      ringMesh.updateMatrix();
      // ringMesh.lookAt( this.camera.position );
    }

    let k;
    for (k = 0; k < this.hotspotsMesh.length; k++) {
      const ringMesh = this.hotspotsMesh[k];
      ringMesh.setRotationFromQuaternion(this.camera.quaternion);
      ringMesh.updateMatrix();
      // ringMesh.lookAt( this.camera.position );
    }
  }

  // Floorplan
  getHeightWidthHotspot() {
    const element = $(this.floorPlanImage.nativeElement);
    const width = element.width() / 22;
    return width < 30 ? width : 30;
  }

  floorPlanHotspotClick(hotspot) {
    if (hotspot && hotspot.media_link && hotspot.media_link.uuid) {
      const oldMesh = this.currentMesh;
      const currentIndex = _.findIndex(this.sphereMesh, {name: hotspot.media_link.uuid });
      if (this.sphereMesh && this.sphereMesh[currentIndex]) {
        this.currentMesh = this.sphereMesh[currentIndex];
        this.changeHighlightReelFromMediaId(hotspot.media_link.uuid);
        this.animateOldNewMesh(oldMesh, this.currentMesh);
      }
    }
  }

  animateOldNewMesh(oldMesh, newMesh) {
    // old mesh
    if (oldMesh !== newMesh) {
      // Remove hotspots
      this.removeHotspotMesh();
      const tweenOpacity1 = new TWEEN.Tween(oldMesh.material)
          .to({ opacity: 0 }, 1200)
          .easing(TWEEN.Easing.Linear.None)
          .onComplete(() => {
            oldMesh.visible = false;
          });
      tweenOpacity1.start();
      // Tween 2 start
      const selectedMedia = _.find(this.mediaData, {uuid: newMesh.name});
      newMesh.visible = true;

      const tweenOpacity2 = new TWEEN.Tween(newMesh.material)
          .to({ opacity: 1 }, 1200)
          .easing(TWEEN.Easing.Linear.None)
          .onUpdate(() => {
            this.resetCameraLatLong();
          })
          .onComplete(() => {
            // Change highlight reel if any
            // this.changeHighlightReelFromMediaId(selectedMedia.uuid);
            this.seletedMediaEmit.emit(selectedMedia);
          });
      tweenOpacity2.start();
    }
  }

  removeComponentProperties() {

    const gl = this.renderer.getContext('webgl');
    if (gl) {
      try {
        gl.getExtension('WEBGL_lose_context').loseContext();
      } catch {
        console.log('error');
      }
    }

    this.removeCssComponents();

    cancelAnimationFrame(this.animateId); // Stop the animation
    this.renderer.domElement.addEventListener('dblclick', null, false); // remove listener to render
    this.scene.remove(this.sphereMesh);
    this.sphereMesh = [];
    this.scene = null;
    this.camera = null;
    this.controls = null;
    this.empty(this.rendererVirtualTourContainer.nativeElement);
    if (this.soundMesh) {
      this.soundMesh.pause();
      // this.soundMesh = undefined;
      // this.soundMesh = undefined;
      // this.audioListener = undefined;
    }
    this.removeData();
  }

  removeCssComponents() {
    if ($('.hotspot-pulse')) {
      $('.hotspot-pulse').each(function() {
        $(this).remove();
      });
    }
    if ($('.info-outer')) {
      $('.info-outer').each(function() {
        $(this).remove();
      });
    }
    let i;
    for (i = 0; i < this.hotspotsMesh.length; i++) {
        if (this.hotspotsMesh[i]) {
          this.cssScene.remove(this.hotspotsMesh[i]);
        }
    }
    this.hotspotsMesh = [];
    // Remove info hotspot mesh
    let j;
    for (j = 0; j < this.hotspotsInfoMesh.length; j++) {
        if (this.hotspotsInfoMesh[j]) {
          this.cssScene.remove(this.hotspotsInfoMesh[j]);
        }
    }
    this.hotspotsInfoMesh = [];
    this.cssRenderer.domElement.addEventListener('dblclick', null, false); // remove listener to render
    this.cssScene = null;
    this.empty(this.cssRendererContainer.nativeElement);
  }

  empty(elem) {
    while (elem.lastChild) {
      elem.removeChild(elem.lastChild);
    }
  }

  removeData() {
    this.cameraConfig.lat = 0;
    this.cameraConfig.lon = 0;
    this.sphereMesh = [];
    this.soundMesh = null;
  }

  getEmbedUrl(code) {
    return `https://www.youtube.com/embed/${code}`;
  }

  readMoreFunction() {
    this.readMoreClicked = !this.readMoreClicked;
  }

  readMoreSummaryFunction() {
    this.readMoreSummaryClicked = !this.readMoreSummaryClicked;
  }

  getYoutubeImage(code) {
    return `https://img.youtube.com/vi/${code}/hqdefault.jpg`;
  }

  openIframeCode(tag) {
    this.selectedInfoTag = tag;
  }

  openInfoImage(tag) {
    this.selectedInfoImage = tag;
  }

  iframeClose() {
    this.selectedInfoTag = undefined;
  }

  imageClose() {
    this.selectedInfoImage = undefined;
  }

  toggleTitle() {
    this.toggle = !this.toggle;
    if (this.toggle) {
      this.highlightToggle = false;
    } else {
      this.toggle = false;
    }
  }
  moreLessButton() {
    this.moreClicked = !this.moreClicked;
  }

  getMoreLessText() {
    if (this.moreClicked) {
      return 'Less';
    }
    return 'More';
  }

}
